export default __webpack_public_path__ + "static/media/Leg_left.8c272e95.svg";